let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("ffEVr"), load("1g8hM")]).then(() => parcelRequire('2OqZy'));